module.exports = __webpack_public_path__ + "static/media/muscle.9ff33c8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/less/muscle.png
// module id = 1075
// module chunks = 0